import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pnc_ic_car",
  "use": "icon-pnc_ic_car-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pnc_ic_car\"><path clip-rule=\"evenodd\" d=\"m20 19c.6 0 1-.4 1-1v-6.8c0-.2 0-.3-.1-.4l-1.9-3.9c-1.2-.6-2.6-.9-4-.9-5 0-9 4-9 9 0 1.4.3 2.8.9 3.9.1 0 .3-.1.4-.2l.4-.4c.2-.2.4-.3.7-.3h7.2c.3 0 .5.1.7.3l.4.4c.2.2.4.3.7.3z\" fill=\"#d1f0c5\" fill-rule=\"evenodd\" /><g fill=\"#1a1a1a\"><path d=\"m20 20h-2.6c-.5 0-1-.2-1.4-.6l-.4-.4h-7.2l-.4.4c-.4.4-.9.6-1.4.6h-2.6c-1.1 0-2-.9-2-2v-6.8c0-.3.1-.6.2-.9l2.6-5.2c.4-.7 1.1-1.1 1.8-1.1h10.8c.8 0 1.4.4 1.8 1.1l2.6 5.2c.1.3.2.6.2.9v6.8c0 1.1-.9 2-2 2zm-2.6-14h-10.8l-2.6 5.2v6.8h2.6l.4-.4c.4-.4.9-.6 1.4-.6h7.2c.5 0 1 .2 1.4.6l.4.4h2.6v-6.8z\" /><path d=\"m23 12h-22c-.6 0-1-.4-1-1s.4-1 1-1h22c.6 0 1 .4 1 1s-.4 1-1 1z\" /><path d=\"m7 15h-1c-.6 0-1-.4-1-1s.4-1 1-1h1c.6 0 1 .4 1 1s-.4 1-1 1z\" /><path d=\"m18 15h-1c-.6 0-1-.4-1-1s.4-1 1-1h1c.6 0 1 .4 1 1s-.4 1-1 1z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pnc_ic_car.svg
// module id = zRRN
// module chunks = 87